import {
  debounce,
  getCookie,
  getDeviceType,
  getCdnUrl,
  logged,
  loadJs,
  sendGoogleEvent,
  sendRequest,
  setCookie,
  showSnackbar,
} from '@html/_common/utils';

export default function TourWishlist({
  common,
  googleEventData: {

    category = 'No Category',
    action = '',
    label = 'No Label',
    params = { eventValue: null },
  } = {},
  getId,
  getTitle,
  getIndex,
  title = '',
  heartSelector = '',
  heartActiveClass = 'active',
  containerSelector = 'body',
  tooltipSelector = null,
  isMultipleHearts = false,
  confirmModalHiddenClass = 'hid',
  confirmModalSelector = null,
  confirmModalCtaSelector = null,
  confirmModalCancelSelector = null,
  callback,
}) {
  let commonJs = common;
  if (typeof sendGoogleEvent !== 'undefined') {
    commonJs = {
      sendGoogleEvent,
      func: { debounce, getCookie, setCookie },
      logged,
      getDeviceType,
      getCdnUrl,
      loadJs,
      sendRequest,
      showSnackbar,
    };
  }
  const BADGE_WISHLIST_SELECTOR = '.js-header-navigation__wishlist--badge';
  const handleWishlistRedirect = () => {
    const defaultUrl = commonJs.logged ? '/wishlists/default' : '/wishlists/new';

    commonJs.sendGoogleEvent(
      'Snackbar',
      'Click',
      'Wishlist',
    );

    window.location.href = defaultUrl;
  };
  const WISHLIST_COOKIE_NAME = 'wishlist_tour_ids';

  const hideConfirmModal = () => {
    const $confirmModal = $(confirmModalSelector);

    $confirmModal.addClass(confirmModalHiddenClass);
    $confirmModal.off();
  };

  const adjustWishlistBadgeNumber = (isActive) => {
    const $badge = $(BADGE_WISHLIST_SELECTOR);
    if (!$badge.length) return;

    const currentValue = parseInt($badge.data('actual-value'), 10);
    const newValue = currentValue + (isActive ? 1 : -1);
    const isMoreThanNine = newValue > 9;

    if (newValue > 0) $badge.removeClass('hid');
    if (newValue === 0) $badge.addClass('hid');

    $badge.html(isMoreThanNine ? '9+' : `${newValue}`);
    $badge.data('actual-value', newValue);
  };

  const displaySuccessSnackbar = ($element) => {
    const message = $element.attr('data-snackbar');
    const icon = { name: 'wishlist', category: 'action' };

    commonJs.showSnackbar.success(message, { icon, onClick: handleWishlistRedirect });
  };

  const toggleHeartIcons = (tourId, $element, isActive) => {
    const tourTitle = getTitle?.($element) || title;
    const defaultAction = `${isActive ? 'Add' : 'Remove'} - ${tourTitle} - ${tourId}`;
    const googleEventAction = action || defaultAction;

    const googleEventParams = {
      ...params,
      eventValue: params.eventValue || getIndex?.($element) || '0',
    };
    const $allHearts = isMultipleHearts ? $(containerSelector).find(heartSelector) : $element;
    commonJs.sendGoogleEvent(category, googleEventAction, label, googleEventParams);

    $allHearts.toggleClass(heartActiveClass, isActive);
  };

  const toggleRequest = commonJs.func.debounce(($element, tourId, isAdding) => {
    const actualState = $element.data('actual-state');
    if ((actualState === 'saved' && isAdding) || (actualState === 'not-saved' && !isAdding)) {
      return;
    }

    commonJs.sendRequest(
      '/api/wishlists',
      {},
      (wishlists) => {
        const { id: defaultWishlistId } = wishlists.find((wishlist) => wishlist.is_default === true);

        commonJs.sendRequest(
          `/api/central/wishlists/${defaultWishlistId}/tours/${tourId}/toggle`,
          {},
          ({ status } = {}) => {
            if (status !== 'OK') {
              adjustWishlistBadgeNumber(!isAdding);
              toggleHeartIcons(tourId, $element, !isAdding);
              return;
            }

            $element.data('actual-state', isAdding ? 'saved' : 'not-saved');

            if (confirmModalSelector) hideConfirmModal();
            if (callback) callback($element, tourId);
          },
        );
      },
      { type: 'GET' },
    );
  }, 350);

  const toggle = ($element) => {
    const tourId = getId?.($element) || $element.data('id');
    const isAdding = !$element.hasClass(heartActiveClass);

    adjustWishlistBadgeNumber(isAdding);
    toggleHeartIcons(tourId, $element, isAdding);
    if (isAdding) {
      displaySuccessSnackbar($element);
    }

    toggleRequest($element, tourId, isAdding);
  };

  const toggleToCookie = ($element) => {
    const tourId = getId?.($element) || $element.data('id');
    const cookieParsed = commonJs.func.getCookie(WISHLIST_COOKIE_NAME);
    const cookieValues = cookieParsed ? cookieParsed.toString().split(',') : [];
    const isTourAdded = cookieValues?.includes(tourId.toString());
    const newCookieValue = isTourAdded
      ? cookieValues.filter((val) => val !== tourId.toString())
      : [...cookieValues, tourId];

    commonJs.func.setCookie({
      name: WISHLIST_COOKIE_NAME,
      value: newCookieValue.toString(),
      path: '/',
    });

    toggleHeartIcons(tourId, $element, !isTourAdded);

    adjustWishlistBadgeNumber(!isTourAdded);

    if (!isTourAdded) displaySuccessSnackbar($element);

    if (confirmModalSelector) hideConfirmModal();
    if (callback) callback($element, tourId);
  };

  const displayConfirmModal = ($element, fn) => {
    const $confirmModal = $(confirmModalSelector);
    $confirmModal.removeClass(confirmModalHiddenClass);

    $confirmModal.on('click', confirmModalCancelSelector, () => hideConfirmModal());
    $confirmModal.on('click', confirmModalCtaSelector, () => fn());
  };

  const onClick = (event) => {
    event.preventDefault();
    const $element = $(event.currentTarget);
    const tourId = getId?.($element) || $element.data('id');
    const isAdding = !$element.hasClass(heartActiveClass);
    const toggleForConfirmModal = commonJs.logged ? () => toggle($element) : () => toggleToCookie($element);

    commonJs.sendGoogleEvent(
      category,
      `Wish list heart click - ${tourId}`,
      label,
      {
        tourID: `${tourId}`,
        ampEventName: isAdding ? 'add_to_wishlist_clicked' : 'remove_from_wishlist_clicked',
      },
    );

    if (commonJs.logged && !confirmModalSelector) return toggle($element);

    if (!commonJs.logged && !confirmModalSelector) return toggleToCookie($element);

    return displayConfirmModal($element, toggleForConfirmModal);
  };

  const toggleTooltip = (event) => {
    const $heartIcon = $(event.currentTarget);
    const $tooltip = $($heartIcon).find(tooltipSelector);

    if (event.type === 'mouseover') {
      $tooltip.removeClass('hid');
    } else if (event.type === 'mouseout') {
      $tooltip.addClass('hid');
    }
  };

  $(containerSelector).on('click', heartSelector, onClick);

  if (!tooltipSelector || commonJs.getDeviceType() !== 'desktop') return;
  $(containerSelector).on('mouseover mouseleave', heartSelector, toggleTooltip);

  // Wishlist login notice: open login/register modal instead of navigating
  let loginRegisterModal;
  const loginRegisterScriptUrl = `${commonJs.getCdnUrl ? commonJs.getCdnUrl() : '/'}include/pw/_common/login_register.min.js`;
  $('body').on('click', '.js-wishlist__login-notice-cta', (e) => {
    e.preventDefault();
    const desiredAction = ($(e.currentTarget).data('action') || 'login').toString();
    const modalType = desiredAction === 'register' ? 'register' : 'login';

    const openModal = () => {
      // eslint-disable-next-line no-undef
      if (!loginRegisterModal) loginRegisterModal = new AOCommonLoginRegister(commonJs);
      loginRegisterModal.openLoginRegisterDialog(modalType, false);
    };

    if (typeof AOCommonLoginRegister !== 'undefined') {
      openModal();
    } else if (commonJs.loadJs) {
      commonJs.loadJs(loginRegisterScriptUrl, openModal);
    } else {
      // Fallback loader
      const script = document.createElement('script');
      script.src = loginRegisterScriptUrl;
      script.onload = openModal;
      document.body.appendChild(script);
    }
  });
}
